import React from "react";
import { CircularProgress, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

/**
 * PrimaryButtonUkoBeMyself constant ( function component used as generic primary button )
 *
 * @exports constant
 * @param {*} { ...props }
 * @returns HTML object
 */

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: "Center",
    width: "100%",
  },
  button: {
    marginRight: theme.spacing(2),
    backgroundColor: theme.buttonUko.buttonUkoBackgroundActive,
    width: "100%",
    height: "40.19px",
    display: "block",
    color: theme.buttonUko.buttonUkoBackgroundSuccess,
    fontSize: "20px",
    borderRadius: "10px",
    "&:hover": {
      backgroundColor: theme.buttonUko.buttonUkoBackgroundActive,
    },
    "& .MuiButton-label": {
      fontSize: "16px",
      fontWeight: "800",
      color: theme.buttonUko.buttonUkoBackgroundSuccess,
      textTransform: "none",
    },
  },
  buttonDisabled: {
    marginRight: theme.spacing(2),
    width: "100%",
    height: "40.19px",
    display: "block",
    fontSize: "20px",
    borderRadius: "10px",
    backgroundColor: theme.buttonUko.buttonUkoBackgroundDisabled,
    color: theme.buttonUko.buttonUkoColorDisabled,
    fontWeight: "bold",
    "& .MuiButton-label": {
      fontSize: "16px",
      fontWeight: "bold",
      textTransform: "none",
    },
  },
  isAnotherButtonDisabled: {
    marginRight: theme.spacing(2),
    width: "100%",
    height: "40.19px",
    display: "block",
    fontSize: "20px",
    borderRadius: "10px",
    backgroundColor: theme.buttonUko.buttonUkoBackgroundDisabled,
    color: theme.buttonUko.buttonUkoColorDisabledResetPwd,
    fontWeight: "bold",
    "& .MuiButton-label": {
      fontSize: "16px",
      fontWeight: "bold",
      textTransform: "none",
    },
  },
}));
const PrimaryButtonUkoBeMyself = ({ ...props }) => {
  const { txtBtn, onClick, type, loading, name, disabled, href, isAnotherButtonDisabled } = props;
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Button
        href={href}
        name={name}
        type={type === "" || type === undefined ? "submit" : type}
        className={loading || disabled ? isAnotherButtonDisabled ? classes.isAnotherButtonDisabled : classes.buttonDisabled : classes.button}
        onClick={onClick}
        disabled={loading || disabled}
      >
        {loading && <CircularProgress size={14} color="secondary" />}
        {!loading && txtBtn}
      </Button>
    </div>
  );
};

export default PrimaryButtonUkoBeMyself;
